const key = 'timeUntilNextTicketDrawInfo';

const setTimeUntilNextTicketDrawInfo = (): void => {
  const afterWeekTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
  const value = new Date(afterWeekTime).toISOString();

  localStorage.setItem(key, value);
};

const checkTimeUntilNextTicketDrawInfo = (): boolean => {
  const time = localStorage.getItem(key);

  if (!time) {
    return true;
  }

  return new Date(time).getTime() - Date.now() <= 0;
};

export { checkTimeUntilNextTicketDrawInfo, setTimeUntilNextTicketDrawInfo };
